import DayliPlanContext from "../../container/coach/dayliPlan/context/dayliPlanContext";
import DayliPlanContainer from "../../container/coach/dayliPlan/dayliPlanContainer";

const DayliPlan = (): React.JSX.Element => (
  <DayliPlanContext>
    <DayliPlanContainer />
  </DayliPlanContext>
);

export default DayliPlan;
